<template>
  <div class="mb-14 grid grid-cols-6 lg:grid-cols-11 col-gap-8">
    <div class="col-span-3 mb-12 lg:mb-0">
      <div class="text-text-label text-xs mb-3-5">{{ $t('securitiesTypes') }}</div>
      <div class="flex items-start justify-start space-x-9">
        <BaseCheckbox :checked="stocks"
                      @change="stocks = !stocks">
          {{ $t('stocks') }}
        </BaseCheckbox>
        <BaseCheckbox :checked="bonds"
                      @change="bonds = !bonds">
          {{ $t('bonds') }}
        </BaseCheckbox>
        <BaseCheckbox :checked="fund"
                      @change="fund = !fund">
          {{ $t('funds') }}
        </BaseCheckbox>
      </div>
    </div>
<!--    <BaseSelect v-model="show" class="col-span-3 mt-2 ml-4"-->
<!--                :options="show_options"-->
<!--                :allow-empty="false"-->
<!--                :select-label="$t('showLabel')"-->
<!--                label="label"-->
<!--                track-by="value"-->
<!--                :searchable="false"-->
<!--                :show-labels="false">-->
<!--    </BaseSelect>-->
  </div>

</template>

<script>
import BaseCheckbox from "@/components/UI/BaseCheckbox";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";

export default {
  name: "InvestmentAssetsFilters",
  components: {BaseSelect, BaseCheckbox},
  data() {
    return {
      stocks: true,
      fund: true,
      bonds: true,
      show: {value: 1, label: 'Все'},
      show_options: [
        {value: 1, label: 'Все'},
        {value: 2, label: 'Не все'}]
    }
  },
  i18n: {
    messages: {
      en: {
        securitiesTypes: 'Securities types',
        stocks: 'Stocks',
        bonds: 'Bonds',
        funds: 'Funds',
        showLabel: 'Display'
      },
      ru: {
        securitiesTypes: 'Типы бумаг',
        stocks: 'Акции',
        bonds: 'Облигации',
        funds: 'Фонды',
        showLabel: 'Показать'
      }
    }
  }
}
</script>

<style scoped>

</style>